import { LandingPageMetaGuard } from './landing-page-meta.guard';
// import { LandingPageGuard } from './landing-page.guard';
import { LandingPagesGuard } from './landings-pages.guard';

// export * from './landing-page.guard';
export * from './landing-page-meta.guard';

export const guards = [LandingPageMetaGuard, LandingPagesGuard];
